import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { Link } from "gatsby"

const NotFoundPage = () => (
  <Layout mainClassName={"not-found"}>
    <SEO title="404: Not found" />

    <div className="container">
      <h1>Page not found.</h1>

      <h3>We can't seem to find the page you're looking for.</h3>

      <Link
        to="/locations?location=Toronto&onboard=true"
        className={"btn btn-primary"}
      >
        Find Spaces
      </Link>
      <Link to={"/"} className={"btn btn-link chev-right ms-4"}>
        Home
      </Link>
    </div>
  </Layout>
)

export default NotFoundPage
